import authentication from "@irati/auth"
import env from "@irati/utils/env"
import environment from "@irati/utils/constants/environment"
import {canvaBusinessIds} from "./canvaBusinessIds"

// Docs: "/docs/web/devToggles.md"
class DevToggles {
  showSSOFeatureFlag() {
    const allowedDomainsForTesting = [
      "home",
      "testaccount1",
      "testaccount2",
      "testaccount3",
      "testaccount4",
      "testaccount5",
      "testaccount6",
      "testaccount12",
      "abcdefg",
      "test-account-self-renewal-training",
      "test-account-upsell",
      "test-account-renew-integ-w-disc"
    ]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showSendingTeamsSetting() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "flavio"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showRecommendedBrandsSlider() {
    const allowedDomainsForTesting = ["zenitechteam", "guild", "raultenant", "home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  isSSOfromVivup() {
    const allowedDomainsForTesting = ["raultenant", "andradasso"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollPayBenefits() {
    // const allowedDomainsForTesting = [
    //   "guild",
    //   "apple",
    //   "kimbo",
    //   "cyber",
    //   "demo-nexus",
    //   "demo-tour",
    //   "demo-tour-creator",
    //   "alberttest",
    //   "home",
    //   "subdomainjamesmay"
    // ]
    // return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
    return true
  }

  showPayrollPayNewFlow() {
    // const allowedDomainsForTesting = ["guild", "apple", "kimbo", "cyber", "demo-nexus", "alberttest", "home", "subdomainjamesmay"]
    // return (
    //   authentication.isLoggedIn() && (allowedDomainsForTesting.includes(authentication.business().subdomain) || this.isNotProduction())
    // )
    return true
  }

  showTopRedeemedPerksCategory() {
    const allowedDomainsForTesting = ["home"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showPayrollOrderManagement() {
    // const allowedDomainsForTesting = [
    //   "guild",
    //   "apple",
    //   "recognition",
    //   "albertteam",
    //   "demo-nexus",
    //   "alberttest",
    //   "albertrecotest",
    //   "home",
    //   "subdomainjamesmay",
    //   "testaccount19"
    // ]
    // return (
    //   authentication.isLoggedIn() && (allowedDomainsForTesting.includes(authentication.business().subdomain) || this.isNotProduction())
    // )
    return true
  }

  showEligibility() {
    return true
  }

  showNewWellness() {
    if (this.businessIs(["codethread"])) return false // off to test staging flag

    // if (this.businessIs(["demo-nexus", "home"])) return true
    //
    // // prettier-ignore
    // if (this.userIs([ // prod test users
    //   "e7c4c0a9-36f7-46e5-8a9f-d43c3822ff11", "a06fff98-ad13-45d6-b980-ded2ebed29a9", "96d153aa-8794-4b57-a700-d1982dbb6083", "08028a89-1f95-48cc-bcac-2af048905ec3",
    //   "5ae109d7-44c3-4880-b525-99359112b114", "12b0770a-e699-4e73-b91b-7878b57841c3", "547ea292-7a1e-48c1-97de-e1915c93ea1a", "8bfcaf3b-a7ff-4367-b9a8-0ca54ebbb185",
    //   "5be9e8a4-260e-40c4-9146-ac0a88f7ac37", "a2898d96-a7b5-4670-9311-540ff60e1232", "6233a557-dd56-461e-91ae-6b07922d570e"
    // ])) return true
    //
    // return this.isProductionGuild() || this.isNotProduction()
    return true
  }

  showNewFavourites() {
    return true
    // if (this.businessIs(["codethread"])) return false // off to test staging flag

    // return this.isProductionGuild() || this.isNotProduction()
  }

  showAssessments() {
    return true

    // if (this.businessIs(["demo-nexus", "demo-global", "demo-public", "demo-wellbeingonly"])) return true

    // return this.isProductionGuild() || this.isNotProduction()
  }

  showAssessmentReporting() {
    return true

    // return this.isProductionGuild() || this.isNotProduction()
  }

  showMarketplace() {
    return true

    // return this.isProductionGuild() || this.isNotProduction()
  }

  showEAP() {
    //return this.isProductionGuild() || this.isNotProduction()
    return true
  }

  showBudgetBulk() {
    // const allowedDomainsForTesting = ["guild", "flavio", "apple", "demo-nexus", "zenitechteam"]
    // return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
    return true
  }

  showAdvancedBudgeting() {
    return this.isNotProduction() || this.businessIs(["demo-nexus", "demo-global", "demo-enhanced", "guild", "demo-justicerewards"])
  }

  showAutoApprovals() {
    return this.isNotProduction() || this.businessIs(["demo-nexus", "demo-global", "demo-enhanced", "guild", "demo-justicerewards"])
  }

  showNewHome() {
    // const allowedDomainsForTesting = ["zenitechteam", "apple", "guild", "demo-nexus", "home", "subdomainjamesmay"]
    // return (
    //   authentication.isLoggedIn() && (allowedDomainsForTesting.includes(authentication.business().subdomain) || this.isNotProduction())
    // )
    return true
  }

  showLimitations() {
    return true
  }

  showSelfRegistration() {
    // const allowedDomainsForTesting = ["apple", "home", "subdomain-co-uk-3", "viorela-onboarding-2", "demo-nexus"]
    // return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
    return true
  }

  showRewardHub() {
    if (this.isProduction()) return this.businessIs(["guild"])
    return this.businessIs(["zenitechteam", "apple"])
  }

  showCommunicationsHub() {
    if (this.isProduction()) return this.businessIs(["guild"])
    return this.businessIs(["zenitechteam", "apple", "kimbo"])
  }

  showNewResendWelcomeEmails() {
    const allowedDomainsForTesting = ["apple"]
    return authentication.isLoggedIn() && allowedDomainsForTesting.includes(authentication.business().subdomain)
  }

  showCanva() {
    const allowedDomainsForTesting = ["rewardcanva", "guild", "demo-global"]
    return (
      authentication.isLoggedIn() &&
      (allowedDomainsForTesting.includes(authentication.business().subdomain) || canvaBusinessIds.includes(authentication.business().uuid))
    )
  }

  showRecognitionAiEnhancement() {
    if (this.isProduction()) return this.businessIs(["home"])
    return true
  }
  showRewardPointsNameCustomization() {
    return authentication.isLoggedIn() && (this.businessIs(["guild", "home"]) || (this.isNotProduction() && !this.businessIs(["apple"])))
  }

  showCsvCustomPoints() {
    return this.isNotProduction() || this.businessIs(["demo-nexus", "demo-global", "demo-enhanced", "guild", "demo-justicerewards"])
  }

  showSurvey() {
    const allowedSurveyNames = ["shokou-test", "kimbo", "guild"]
    return authentication.isLoggedIn() && allowedSurveyNames.includes(authentication.business().subdomain)
  }

  private isProduction() {
    return env.ENVIRONMENT_NAME === environment.PRODUCTION
  }

  private isNotProduction() {
    return !this.isProduction()
  }

  private isProductionGuild() {
    return this.isProduction() && this.businessIs(["guild"])
  }

  private businessIs(domains: string[]) {
    return authentication.isLoggedIn() && domains.includes(authentication.business().subdomain)
  }

  private userIs(users: string[]) {
    return authentication.isLoggedIn() && users.includes(authentication.user().uuid ?? "nope")
  }
}

export default new DevToggles()
